
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { HardwareUpgradeAPI } from "@/common/api/hardwareManage/hardwareUpgradeList";
import { CommonApi } from "@/common/api/common";

// import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";

export const pageApiList = getPageAPIs(HardwareUpgradeAPI);

import {
  commonDefaultDeviceGateType2Ch,
  // transferUserLevel2ch,
  defaultUserMemberList,
  getCommonList,
} from "@/common/config";

const defaultEditHardForm: any = {
  device_type: '',
  file_id: '',
  title: '',
  content: '',
  version: ''
}



const deviceType2Ch: string[] = [
  ...commonDefaultDeviceGateType2Ch
]

@Component({
  filters: {
    showDeviceTypeName(type: number) {
      return deviceType2Ch[type] || '未知'
    }
  }
})
export default class UserList extends Vue {
  private utilInstance: any;
  private deepLoopUtil: any;

  private hardwareUpgradeApi: any;

  private commonApi: any;

  private chooseDeviceTypeList: any[] = getCommonList(commonDefaultDeviceGateType2Ch, 1)


  constructor() {
    super();
    this.hardwareUpgradeApi = new HardwareUpgradeAPI();

    this.commonApi = new CommonApi();

    this.utilInstance = new Util();

    this.deepLoopUtil = new DeepLoop();

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  private form: any = {
    device_name: "", // 设备名称
    product_id: "", // 设备ID
  };

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.hardwareUpgradeApi.getHardwareUpgradeTableList(
      this.getHardwareUpgradeTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getHardwareUpgradeTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // product_id, // 设备ID
      // // userName, // 用户昵称
      // device_name, // 设备名称
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    // if (product_id) {
    //   outerParams.product_id = product_id;
    // }


    // if (device_name) {
    //   outerParams.device_name = device_name;
    // }

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    if (
      mode == "exportExcel" &&
      !(outerParams.created_start_time && outerParams.created_end_time)
    ) {
      this.$message.error("请选择时段导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  private onWakeHardFormDialog() {
    const editHardForm = {
      ...this.deepLoopUtil.deepCopy(defaultEditHardForm, false)
    }

    this.editHardForm = editHardForm

    this.editHardDialogVisible = true
  }


  private editHardDialogVisible: boolean = false;

  private editHardInfoLoading: boolean = false;

  private editHardForm: any = {
    
  };

  private onConfirmAddHardwareUpgrade() {
    const params = this.getHardwareUpgradeParams()

    if (typeof params !== 'object') return 

    this.editHardInfoLoading = true
    this.hardwareUpgradeApi.addHardwareUpgrade(params, () => {
      this.editHardInfoLoading = false

      this.editHardDialogVisible = false

      this.getTable()
    }, () => {
      this.editHardInfoLoading = false
    })
  }

  private getHardwareUpgradeParams() {
    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const params: any = {

    }

    const editHardForm = this.editHardForm

    const {
      // device_type,
      file_id,
      // title,
      // content,
      // version
    } = editHardForm

    const keys = ["device_type", "title", "content", "version"];

    const key2EndKey: any = {
      device_type: "device_type",
      title: "title",
      content: "content",
      version: "version"
    };

    const key2ErrMsg: any = {
      device_type: "设备不能为空",
      title: "标题不能为空",
      content: "更新内容不可为空",
      version: "版本号不可为空"
    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (editHardForm[key]) {
        const errMsg = key2ErrMsg[`${key}_${editHardForm[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = editHardForm[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }

    if (file_id) {
      params.file_id = file_id
    } else {
      showErrorMessage('请上传更新包');
      return false
    }



    return params
  }

  // 上传 升级包文件
  private upgradeFileUploading: boolean = false;
  private handleUploadUpgradeFile(file: any, fileList: any[]) {
    console.log(file, fileList, "file", "fileList");

    this.upgradeFileUploading = true;
    this.commonApi.getOssFile(
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 升级包上传成功");

        const { data } = res;

        const { data: callbackData } = data;

        const { item: uploadImgObj } = callbackData || {};

        const { id, url } = uploadImgObj;

        this.$set(this.editHardForm, "file_id", id);
        this.$set(this.editHardForm, "file_path", url);

        this.upgradeFileUploading = false;
      },
      () => {
        this.$message.error("升级包上传失败");

        this.upgradeFileUploading = false;
      }
    );
  }

  // 查看用户订单
  // private handleGoUserOrderList(userItem: any): void {
  //   console.log(userItem, "userItem");

  //   const { id: userId } = userItem || {};

  //   if (userId) {
  //     this.$router.push({
  //       path: "/orderList",
  //       query: {
  //         userId,
  //       },
  //     });
  //   }
  // }

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   id: "用户ID",
  //   user_name: "用户昵称",
  //   phone: "用户手机号",
  //   gender_name: "性别",
  //   invite_code: "邀请码",
  //   birthday: "生日",
  //   user_level_name: "会员等级",
  //   created_at: "注册时间",
  //   account_status_name: "账户状态",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "id",
  //   "user_name",
  //   "phone",
  //   "gender_name",
  //   "invite_code",
  //   "birthday",
  //   "user_level_name",
  //   "created_at",
  //   "account_status_name",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getHardwareUpgradeTableListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.hardwareUpgradeApi.exportExcelUserList(
  //     params,
  //     (res: any) => {
  //       const { created_start_time, created_end_time } = params || {};

  //       const filename = `用户列表 ${created_start_time}到${created_end_time}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { gender, type, status } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             // if (!forbidTime) {
  //             newItem.gender_name = this.transferGender2ch[gender];

  //             newItem.user_level_name = this.transferUserLevel2ch[type];

  //             newItem.account_status_name =
  //               this.transferUserAccountStatus2ch[status];
  //             // }

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
